// extracted by mini-css-extract-plugin
module.exports = {"link":"_0fce717cdb--link--ym40S"};